import { routes } from "routing";

export const path = {
  edit: "edit",
  expenses: "expenses",
  team: "team",
  search: "search",
  category: "category",
  member: "member",
  account: "account",
  profile: "profile",
  delete: "delete",
  changeOrg: "changeOrg",
  accessRequests: "accessRequests",
  settings: "settings",
  about: "about",
  licences: "licences",
  credits: "credits",
  themes: "themes",
  languages: "languages",
  calendar: "calendar",
  widgets: "widgets",
  notifications: "notifications",
  localNotifications: "local-notifications",
  pending: "pending",
  chatNotifications: "chat-notifications",
  itineraries: "itineraries",
  subscription: "subscription",
  setup: "setup",
  addUsers: "team",
  authentication: "authentication",
  oauth: "oauth",
  callback: "callback",
  signin: "signin",
  signUp: "signUp",
};

export const Paths = {
  home: {
    expenses: `/${path.edit}/${path.expenses}`,
  },

  // Values come from the route registry; key names here can differ from the registry's.
  account: {
    acountPage: routes.account.page.path,

    profile: {
      profilePage: routes.account.profile.path,
      profileDelete: routes.account.delete.path,
      profileEdit: routes.account.profileEdit.path,
    },

    changeOrg: routes.account.organisations.path,
    accessRequests: routes.account.accessRequests.path,

    settings: {
      settingsPage: routes.account.settings.page.path,

      about: {
        aboutPage: routes.account.settings.about.path,
        licences: routes.account.settings.licences.path,
        credits: routes.account.settings.credits.path,
      },

      themes: routes.account.settings.themes.path,
      booking: routes.account.settings.booking.path,
      languages: routes.account.settings.language.path,
      calendar: routes.account.settings.calendar.path,
      time: routes.account.settings.time.path,
      widgets: routes.account.settings.widgets.path,
      team: routes.account.settings.team.path,

      notifications: {
        notificationsSettingsPage: routes.account.settings.notifications.path,

        localNotifications: {
          localNotifications: routes.account.settings.localNotifications.path,

          localNotificationsPending: routes.account.settings.localNotificationsPending.path,
        },

        chatNotifications: routes.account.settings.chatNotifications.path,
      },

      home: routes.account.settings.homeScreen.path,
    },

    itineraries: routes.account.itineraries.path,
    subscription: routes.account.subscription.path,
  },

  editGeneralActivity: (activityID: string) => routes.edit.activityItem.build({ itemId: activityID }),

  newItinerary: `${routes.edit.eventInfo.path}?new=true`,

  editEventInfo: routes.edit.eventInfo.path,
};
